import { render, staticRenderFns } from "./ViewsSwitcher.vue?vue&type=template&id=d8f68d02&scoped=true&"
import script from "./ViewsSwitcher.vue?vue&type=script&lang=js&"
export * from "./ViewsSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f68d02",
  null
  
)

export default component.exports